import { useContext } from 'react'
import { useIntl } from 'react-intl'
import { Box, Typography } from '@mui/material'
import {
  BottomBar,
  Link,
  LinkType,
  PageContainer,
  StyledTranslationOrText
} from '../../components'
import { styled } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { AuthContext } from '../../contexts'

const EMPTY_DEFAULT_MESSAGE = ' '

const useStyles = makeStyles((theme) => ({
  logoutPageImage: {
    alignItems: 'center',
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    },
    justifyContent: 'center',
    backgroundImage: `url(${theme.variables.logoutImage})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: theme.variables.logoutImageBackgroundSize
  },
  whiteSpacePre: {
    whiteSpace: 'pre-line'
  }
}))

const LogoutPageLogoutBox = styled(Box)({
  margin: '4rem'
})

const LogoutDescription = styled(Typography)({
  marginBottom: '2rem',
  whiteSpace: 'pre-line'
})

const LogoutText = styled(Typography)({
  marginBottom: '2rem'
})

const LogoutTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.variables.fontSizes.logOutTitle,
  fontWeight: 'bold',
  marginBottom: '2rem',
  whiteSpace: 'pre-line'
}))

interface LoginPageLinkProps {
  linkLabelId: string
}

export const LoginPageLink = ({ linkLabelId }: LoginPageLinkProps) => {
  const { closeLoggedOutPage } = useContext(AuthContext)
  const classes = useStyles()

  return (
    <Box alignItems="flex-start" display="flex" flexDirection="column">
      <Link onClick={closeLoggedOutPage} href="#" type={LinkType.BASIC}>
        <Box
          alignItems="center"
          display="flex"
          flexDirection="row"
          className={classes.whiteSpacePre}
        >
          <StyledTranslationOrText translationId={linkLabelId} />
          <NavigateNextIcon fontSize="large" />
        </Box>
      </Link>
    </Box>
  )
}

export const LogoutPage = () => {
  const { formatMessage } = useIntl()
  const classes = useStyles()

  const logoutDescription = formatMessage({
    id: 'pages.logoutPage.description'
  })
  const logoutTitle = formatMessage({ id: 'pages.logoutPage.title' })
  const unionLogoutText = formatMessage({
    defaultMessage: EMPTY_DEFAULT_MESSAGE,
    id: 'pages.logoutPage.additionalDescription'
  })

  return (
    <>
      <PageContainer>
        <Box display="flex" flexDirection="row" flexGrow={1} flexShrink={1}>
          <Box
            className={classes.logoutPageImage}
            flexBasis="60%"
            flexGrow={1}
            flexShrink={1}
          />
          <Box
            alignItems="flex-start"
            display="flex"
            flexBasis="40%"
            flexGrow={1}
            flexShrink={1}
            justifyContent="center"
          >
            <LogoutPageLogoutBox display="flex" flexDirection="column">
              <LogoutTitle>{logoutTitle}</LogoutTitle>
              <LogoutDescription>{logoutDescription}</LogoutDescription>
              <LogoutText>{unionLogoutText}</LogoutText>
              <LoginPageLink linkLabelId="pages.logoutPage.logoutPageLinkLabel" />
            </LogoutPageLogoutBox>
          </Box>
        </Box>
        <BottomBar showMobile />
      </PageContainer>
    </>
  )
}
